import useSWR from 'swr';
// api
import getTicketFormSettings from '../../api/getTicketFormSettings';

// calls api to get ticketSettings
const ticketFormSettingsFetcher = async (...args) => {
  return getTicketFormSettings(...args);
};

// returns ticketSettings with loading state
const useTicketFormSettings = () => {
  const ticketFormSettingsRequestKey = 'ticketSettings';

  const { data: ticketFormSettings, error: ticketFormSettingsError } = useSWR(
    ticketFormSettingsRequestKey,
    ticketFormSettingsFetcher
  );

  const isLoadingTicketFormSettings = typeof ticketFormSettings === 'undefined';

  return {
    isLoadingTicketFormSettings,
    ticketFormSettings,
    ticketFormSettingsError,
  };
};

export default useTicketFormSettings;
